import http from '@services/http'
const AUtil = require('crypto-js');
const key = AUtil.enc.Base64.parse('sQPoC/1do9BZMkg8I5c09A==');

export default {
  getDataview(): Promise<any> {
    return http.get('/user-api/na/dataview', {});
    // return new Promise(resolve => {
    //   resolve({
    //     data: {
    //       articleCount: 123123,
    //       journalCount: 42342,
    //       subjectStatisticsList: [
    //         {
    //           subjectId: 1,
    //           subjectName: 'subjectName',
    //           articleCount: 'articleCount',
    //           journalCount: 'articleCount'
    //         }
    //       ]
    //     }
    //   })
    // })
  },

  getSubjectJournalList(data: any): Promise<any> {
    return http.get(`user-api/na/subject/journal/list`, data || {})
    // return new Promise(resolve => {
    //   resolve({
    //     code: 200,
    //     data: {
    //       articleCount: 123123,
    //       journalCount: 42342,
    //       journalList: [
    //         {
    //           journalId: 1,
    //           issn: 'issn',
    //           eissn: 'eissn',
    //           journalName: 'journalName',
    //           journalEname: 'journalEname',
    //           journalShortEname: 'journalShortEname',
    //           indexList: [
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             },
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             }
    //           ]
    //         },
    //         {
    //           journalId: 1,
    //           issn: 'issn',
    //           eissn: 'eissn',
    //           journalName: 'journalName',
    //           journalEname: 'journalEname',
    //           journalShortEname: 'journalShortEname',
    //           indexList: [
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             },
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             }
    //           ]
    //         },
    //         {
    //           journalId: 1,
    //           issn: 'issn',
    //           eissn: 'eissn',
    //           journalName: 'journalName',
    //           journalEname: 'journalEname',
    //           journalShortEname: 'journalShortEname',
    //           indexList: [
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             },
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             }
    //           ]
    //         },
    //         {
    //           journalId: 1,
    //           issn: 'issn',
    //           eissn: 'eissn',
    //           journalName: 'journalName',
    //           journalEname: 'journalEname',
    //           journalShortEname: 'journalShortEname',
    //           indexList: [
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             },
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             }
    //           ]
    //         },
    //         {
    //           journalId: 1,
    //           issn: 'issn',
    //           eissn: 'eissn',
    //           journalName: 'journalName',
    //           journalEname: 'journalEname',
    //           journalShortEname: 'journalShortEname',
    //           indexList: [
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             },
    //             {
    //               remark: 'remark',
    //               CJCRIF: 'CJCRIF',
    //               JCRIF: 'JCRIF'
    //             }
    //           ]
    //         }
    //       ]
    //     }
    //   })
    // })
  },

  getSubjectArticleList(data: object): Promise<any> {
    return http.get('user-api/na/subject/article/list', data || {})
    // return new Promise(resolve => {
    //   resolve({
    //     code: 200,
    //     data: {
    //       articleCount: 123123,
    //       journalCount: 42342,
    //       articleList: [
    //         {
    //           articleId: '',
    //           titleEn: 'titleEn',
    //           titleCn: 'titleCn',
    //           authorCn: '',
    //           authorEn: 'authorEn',
    //           doi: '',
    //           year: '',
    //           volume: '',
    //           issue: '',
    //           startPage: '',
    //           endPage: '',
    //           url: '',
    //           publishedTime: '',
    //           abstractDesc: 'abstractDescabstractDescabstractDescabstractDesc',
    //           pmid: ''
    //         },
    //         {
    //           articleId: '',
    //           titleEn: 'titleEn',
    //           titleCn: 'titleCn',
    //           authorCn: '',
    //           authorEn: 'authorEn',
    //           doi: '',
    //           year: '',
    //           volume: '',
    //           issue: '',
    //           startPage: '',
    //           endPage: '',
    //           url: '',
    //           publishedTime: '',
    //           abstractDesc: 'abstractDescabstractDescabstractDescabstractDesc',
    //           pmid: ''
    //         },
    //         {
    //           articleId: '',
    //           titleEn: 'titleEn',
    //           titleCn: 'titleCn',
    //           authorCn: '',
    //           authorEn: 'authorEn',
    //           doi: '',
    //           year: '',
    //           volume: '',
    //           issue: '',
    //           startPage: '',
    //           endPage: '',
    //           url: '',
    //           publishedTime: '',
    //           abstractDesc: 'abstractDescabstractDescabstractDescabstractDesc',
    //           pmid: ''
    //         },
    //         {
    //           articleId: '',
    //           titleEn: 'titleEn',
    //           titleCn: 'titleCn',
    //           authorCn: '',
    //           authorEn: 'authorEn',
    //           doi: '',
    //           year: '',
    //           volume: '',
    //           issue: '',
    //           startPage: '',
    //           endPage: '',
    //           url: '',
    //           publishedTime: '',
    //           abstractDesc: 'abstractDescabstractDescabstractDescabstractDesc',
    //           pmid: ''
    //         }
    //       ]
    //     }
    //   })
    // })
  },

  searchJournal(data: any): Promise<any> {
    return http.get('user-api/na/journal/search', data || {})
    // return new Promise(resolve => {
    //   resolve({
    //     data: {
    //       total: 899,
    //       journalList: [
    //         {
    //           journalId: 1,
    //           issn: 'issn',
    //           eissn: 'eissn',
    //           journalName: 'journalName',
    //           journalEname: 'journalEname',
    //           journalShortEname: 'journalShortEname',
    //           indexList: [
    //             {
    //               description: 'description',
    //               cjcrif: 'cjcrif',
    //               jcrif: 'jcrif'
    //             }
    //           ]
    //         },
    //         {
    //           journalId: 1,
    //           issn: 'issn',
    //           eissn: 'eissn',
    //           journalName: 'journalName',
    //           journalEname: 'journalEname',
    //           journalShortEname: 'journalShortEname',
    //           indexList: [
    //             {
    //               description: 'description',
    //               cjcrif: 'cjcrif',
    //               jcrif: 'jcrif'
    //             }
    //           ]
    //         }
    //       ],
    //       indexList: [
    //         {
    //           subjectId: 'subjectId',
    //           subjectName: 'subjectName',
    //           count: 'adfad'
    //         },
    //         {
    //           subjectId: 'subjectId',
    //           subjectName: 'subjectName',
    //           count: 'adfad'
    //         },
    //         {
    //           subjectId: 'subjectId',
    //           subjectName: 'subjectName',
    //           count: 'adfad'
    //         }
    //       ]
    //     }
    //   })
    // })
  },
  searchArticle(data: any): Promise<any> {
    return http.get('user-api/na/article/search', data || {})
    // return new Promise(resolve => {
    //   resolve({
    //     data: {
    //       total: 899,
    //       articleList: [
    //         {
    //           articleId: '',
    //           titleEn: '',
    //           titleCn: '',
    //           authorCn: '',
    //           authorEn: '',
    //           doi: '',
    //           year: '',
    //           volume: '',
    //           issue: '',
    //           startPage: '',
    //           endPage: '',
    //           url: '',
    //           publishedTime: Date.now(),
    //           abstractDesc: '',
    //           pmid: ''
    //         }
    //       ],
    //       yearIndexList: [
    //         {
    //           year: 2012,
    //           count: 1000
    //         }
    //       ]
    //     }
    //   })
    // })
  },

  keywordSearchStat(data: any): Promise<any> {
    return http.get('user-api/na/article/keywordSearchStat', data || {})
  },
  getJournalById(journalId: any): Promise<any> {
    return http.get(`user-api/journal/detail?uid=${journalId}`, null)
  },
  getJournalIssueYears(journalId: any): Promise<any> {
    return http.get(`user-api/journal/issue/allYear?uid=${journalId}`, null)
  },
  getJournalIssuesList(data: any): Promise<any> {
    return http.get('user-api/journal/issueList', data || {})
  },
  getJournalIssuesArticalList(data: any): Promise<any> {
    return http.get('user-api/na/journal/issue/article/list', data || {})
  },
  getArticleById(data: any): Promise<any> {
    return http.get('user-api/na/article/detail', data || {})
  },

  getAuid(journalId: any) {
    let encrypted = AUtil.AES.encrypt(journalId, key, {
      mode: AUtil.mode.ECB,
      padding: AUtil.pad.Pkcs7,
    });
    const auid = encodeURIComponent(encrypted.ciphertext.toString(AUtil.enc.Base64));
    return auid;
  },


}
